export const cmeDisclaimer = `The market data is the property of Chicago Mercantile Exchange Inc. or it’s licensors as applicable.\nAll rights reserved, or otherwise licensed by Chicago Mercantile Exchange Inc.`;
